<app-traitement-data titre="Volume courant (médiane - 95%)"
    [sousTitre]="patient!.tableauDeBord?.volumeCourantMediane?.date | aLaDateDu">
    {{ (patient!.tableauDeBord?.volumeCourantMediane?.value) ?? 'Ø' }} -
    {{ (patient!.tableauDeBord?.volumeCourant95?.value) ?? 'Ø' }}
</app-traitement-data>